import config from "../pages/Config"
import AddRole from "../pages/Roles/AddRole"
import EditRole from "../pages/Roles/EditRole"
import RolesIndex from "../pages/Roles/RolesIndex"
import AddStaff from "../pages/Staff/AddStaff"
import EditStaff from "../pages/Staff/EditStaff"
import StaffIndex from "../pages/Staff/StaffIndex"
import TutorIndex from "../pages/Tutor/TutorIndex"
import AddTutor from "../pages/Tutor/AddTutor"
import EditTutor from "../pages/Tutor/EditTutor"
import TutorSlots from "../pages/Tutor/TutorSlots"
import TutorAvailability from "../pages/Tutor/TutorAvailability"
import AuditLogs from "../pages/AuditLogs"
import AuditLogDetails from "../pages/AuditLogs/AuditLogDetails"
import PaymentsIndex from "../pages/Payments/Index"
import VideosIndex from "../pages/Videos/Index"
import GeneratedImages from "../pages/AIGenerated/GeneratedImages"
import ImageGallery from "../pages/AIGenerated/ImageGallery"
import GeneratedVideos from "../pages/AIGenerated/GeneratedVideos"
import VideosGallery from "../pages/AIGenerated/VideosGallery"
import AiChats from "../pages/AIChats/Index"
import AITokenLimits from "../pages/Settings/AITokenLimits"
import ManageAIKey from "../pages/Settings/ManageAIKey"
import RestrictedWords from "../pages/Settings/RestrictedWords"
import PrivacyPolicy from "../pages/Settings/PrivacyPolicy"
import Category from "../pages/Settings/Category"
import PlansSubscriptions from "../pages/Settings/PlansSubscriptions"
import CreatorIndex from "../pages/Settings/CreatorIndex"
import AddCreator from "../pages/Settings/AddCreator"
import EditCreator from "../pages/Settings/EditCreator"
import UsersIndex from "../pages/Users/Index"
import "../App.css"

// Module IDs match the permission matrix defined in AddRole.js:
// 1=Dashboard, 2=Videos, 3=Generated Images, 4=Generated Videos, 5=AI Chats,
// 6=Staff, 7=Roles & Permissions, 8=Audit Logs, 9=Users,
// 10=AI Token Limits, 11=Manage AI Keys, 12=Restricted Words,
// 13=Privacy Policy, 14=Category, 15=Tutors, 18=Payments
// type: 1=view, 2=add, 3=edit, 4=delete

export const privateRoutes = [
    {
        path: `${config.appUrl}tutors`,
        component: TutorIndex,
        module_id: 15,
        type: 1
    },
    {
        path: `${config.appUrl}add-tutor`,
        component: AddTutor,
        module_id: 15,
        type: 2
    },
    {
        path: `${config.appUrl}edit-tutor/:tutorId`,
        component: EditTutor,
        module_id: 15,
        type: 3
    },
    {
        path: `${config.appUrl}tutors/slots/:tutorId`,
        component: TutorSlots,
        module_id: 15,
        type: 1
    },
    {
        path: `${config.appUrl}tutors/availability/:tutorId`,
        component: TutorAvailability,
        module_id: 15,
        type: 1
    },
    {
        path: `${config.appUrl}staff`,
        component: StaffIndex,
        module_id: 6,
        type: 1
    },
    {
        path: `${config.appUrl}add-staff`,
        component: AddStaff,
        module_id: 6,
        type: 2
    },
    {
        path: `${config.appUrl}edit-staff/:userKey`,
        component: EditStaff,
        module_id: 6,
        type: 3
    },
    {
        path: `${config.appUrl}roles`,
        component: RolesIndex,
        module_id: 7,
        type: 1
    },
    {
        path: `${config.appUrl}add-role`,
        component: AddRole,
        module_id: 7,
        type: 2
    },
    {
        path: `${config.appUrl}edit-role/:role_id`,
        component: EditRole,
        module_id: 7,
        type: 3
    },
    {
        path: `${config.appUrl}audit`,
        component: AuditLogs,
        module_id: 8,
        type: 1
    },
    {
        path: `${config.appUrl}audit/:id`,
        component: AuditLogDetails,
        module_id: 8,
        type: 1
    },
    {
        path: `${config.appUrl}payments`,
        component: PaymentsIndex,
        module_id: 18,
        type: 1
    },
    {
        path: `${config.appUrl}videos`,
        component: VideosIndex,
        module_id: 2,
        type: 1
    },
    {
        path: `${config.appUrl}ai-generated/images`,
        component: GeneratedImages,
        module_id: 3,
        type: 1
    },
    {
        path: `${config.appUrl}ai-generated/images/:kidKey`,
        component: ImageGallery,
        module_id: 3,
        type: 1
    },
    {
        path: `${config.appUrl}ai-generated/videos`,
        component: GeneratedVideos,
        module_id: 4,
        type: 1
    },
    {
        path: `${config.appUrl}ai-generated/videos/:kidKey`,
        component: VideosGallery,
        module_id: 4,
        type: 1
    },
    {
        path: `${config.appUrl}ai-chats`,
        component: AiChats,
        module_id: 5,
        type: 1
    },
    {
        path: `${config.appUrl}settings/plans`,
        component: PlansSubscriptions,
        module_id: 17,
        type: 1
    },
    {
        path: `${config.appUrl}settings/ai-token-limits`,
        component: AITokenLimits,
        module_id: 10,
        type: 1
    },
    {
        path: `${config.appUrl}settings/manage-ai-keys`,
        component: ManageAIKey,
        module_id: 11,
        type: 1
    },
    {
        path: `${config.appUrl}settings/restricted-words`,
        component: RestrictedWords,
        module_id: 12,
        type: 1
    },
    {
        path: `${config.appUrl}settings/privacy-policy`,
        component: PrivacyPolicy,
        module_id: 13,
        type: 1
    },
    {
        path: `${config.appUrl}settings/category`,
        component: Category,
        module_id: 14,
        type: 1
    },
    {
        path: `${config.appUrl}settings/creators`,
        component: CreatorIndex,
        module_id: 16,
        type: 1
    },
    {
        path: `${config.appUrl}settings/add-creator`,
        component: AddCreator,
        module_id: 16,
        type: 2
    },
    {
        path: `${config.appUrl}settings/edit-creator/:creatorId`,
        component: EditCreator,
        module_id: 16,
        type: 3
    },
    {
        path: `${config.appUrl}users`,
        component: UsersIndex,
        module_id: 9,
        type: 1
    }
]
